const schema = process.env.NODE_ENV === 'production' ? 'https' : 'http';

export const PEQUITY_BASE_URL = process.env.VUE_APP_PEQUITY_BASE_URL ?? 'localhost:8000';
export const PEQUITY_API_URL = `${schema}://${process.env.VUE_APP_PEQUITY_BASE_URL}/api` as string;
// We're checking VUE_APP_PEQUITY_SOCKETS_BASE_URL, just in case we want to have ability to run a standalone ws server if needed.
export const PEQUITY_SOCKETS_BASE_URL = process.env.VUE_APP_PEQUITY_SOCKETS_BASE_URL || PEQUITY_BASE_URL;
export const PEQUITY_SOCKET_PROTOCOL = process.env.NODE_ENV === 'production' ? 'wss' : 'ws';
export const POSTHOG_API_KEY = process.env.VUE_APP_POSTHOG_API_KEY as string;
export const POSTHOG_HOST = process.env.VUE_APP_POSTHOG_HOST as string;
export const POSTHOG_DEV = (process.env.VUE_APP_POSTHOG_DEV || '') as string;
